var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHubfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 450",
    style: {
      enableBackground: "new 0 0 1000 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 796.2127,
    y1: 184.0526,
    x2: 923.0443,
    y2: 310.8841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#332CAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9251BD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M820.6,308.4l9.8-96.9h-9.8c-1.9,0-2.9-1.6-2.7-3.5l0.4-3.3c0.2-2.1,1.8-3.5,3.5-3.5h9.7l0.7-6 c2.5-20.4,10.7-33.2,28.4-33.2c13.1,0,20.9,6,23.9,8.4c1.1,0.8,1.4,2.5,0.3,4.1l-2.6,3.8c-1.4,2.1-2.8,1.6-4.7,0.2 c-3.6-2.5-8.1-6-16.4-6c-11.4,0-15.6,10-17.2,22.8l-0.7,6h42.3c1.7,0,3.2,1.7,3,3.5l-7,66.2c-0.3,1.9-1.9,3.5-3.5,3.5h-5.4 c-1.6,0-3.1-1.6-2.8-3.5l6.3-59.4h-33.9l-9.6,96.9c-0.3,1.9-1.9,3.6-3.5,3.6h-5.7C821.5,312.1,820.4,310.3,820.6,308.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 839.0867,
    y1: 141.1786,
    x2: 965.9182,
    y2: 268.0102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#332CAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9251BD"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M911.1,256.2l4.8-44.6h-8.2c-1.9,0-3.2-1.6-3-3.5l0.5-3.3c0.6-2.1,1.6-3.5,3.4-3.5h8.7l2-20.3 c0.3-1.9,1.8-3.3,3.5-3.5l5.7-0.3c1.6-0.2,2.9,1.6,2.7,3.5l-2.1,20.6h18.7c1.9,0,2.9,1.4,2.8,3.5l-0.4,3.3c-0.1,1.9-1.8,3.5-3.5,3.5 h-18.8l-4.9,45.1c-0.7,7.3,2.5,8.4,6,8.4c3.6,0,9.1-3.2,11.4-5.1c2.3-1.9,3.6,0,4.3,1.4l1.9,4c1,2.2,0.1,3.3-1.7,4.7 c-3.4,2.7-10.4,6-18,6C915.2,276.1,909.9,267.4,911.1,256.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.8373,
    y1: 62.2748,
    x2: 635.0583,
    y2: 751.1704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01E0E9"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.8,267.7l-12.6,120.1c-0.3,3.1-2.9,5.4-6,5.4H200c-3.6,0-6.4-3.1-6-6.6l12.5-119.1c1.7-15.9-9-28.7-24.3-30 c-0.3,0-0.7,0-1.2-0.1c-1.3,0-1.8-1.6-0.8-2.5c0,0,0.1-0.1,0.1-0.1c6.3-6.2,15.7-7.5,22.3-3c10.9,7.4,17.4,20.4,15.9,35.4h0 L207,377.9c-0.2,1.8,1.2,3.3,3,3.3h54.1c1.5,0,2.8-1.2,3-2.7l11.6-110.8c3.8-36.5-22.8-66.8-59.3-66.8c-36.5,0.1-69.2,29.7-73,66.2 l-12.7,120.7c-0.3,3.1-2.9,5.4-6,5.4H55.6c-3.6,0-6.4-3.1-6-6.6L83.7,61.9c0.3-3.1,2.9-5.4,6-5.4h72.2c3.6,0,6.4,3.1,6,6.6 L154.4,191c-0.4,4.1-2.6,8.1-5.9,11c-1.9,1.6-3.5,3.5-5.1,5.4c-1,1.2-2.8,0.5-2.6-0.9l14.2-134.7c0.2-1.8-1.2-3.3-3-3.3H97.8 c-1.5,0-2.8,1.2-3,2.7L62.6,377.9c-0.2,1.8,1.2,3.3,3,3.3h54.1c1.5,0,2.8-1.2,3-2.7l11.7-111.4c4.5-43.1,43.1-78.1,86.2-78.2 C263.8,188.7,295.3,224.5,290.8,267.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.9602,
    y1: -76.9182,
    x2: 771.5596,
    y2: 613.6812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01E0E9"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.2,195.5c0.4-3.6-2.4-6.6-6-6.6h-5.4h-60.2H473c-3.1,0-5.7,2.3-6,5.4l-0.7,6.6l-11.9,113.5 c-3.8,36.5-36.9,66.8-73.3,66.8c-36.5-0.1-63-29.7-59.1-66.2l11.7-111.4c0.2-1.5,1.5-2.7,3-2.7h54.1c1.8,0,3.2,1.5,3,3.3L382.1,315 h0c-1.5,15,5,28,15.9,35.4c6.6,4.5,16,3.2,22.3-3c0,0,0.1-0.1,0.1-0.1c1-1,0.5-2.5-0.8-2.5c-0.2,0-0.4,0-0.5,0 c-15.6-1-26.7-13.8-25-30l12.5-119.1c0.4-3.6-2.4-6.6-6-6.6h-5.4h-60.2h-6.6c-3.1,0-5.7,2.3-6,5.4L310,314.4 c-4.5,43.2,27,79,70.2,78.8c43.1-0.2,81.6-35.1,86.2-78.2l11.7-111.4c0.2-1.5,1.5-2.7,3-2.7h54.1c1.8,0,3.2,1.5,3,3.3l-18.3,174.2 c-0.2,1.7-1.7,3-3.3,3h-59.4c-3.8,0-7.6,1.5-10.7,4.1c-2.1,1.8-4.4,3.6-6.6,5.3c-1.2,0.9-0.8,2.7,0.7,2.7h84.8c3.1,0,5.7-2.3,6-5.4 l19.4-187.2L551.2,195.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.2906,
    y1: -206.5258,
    x2: 901.418,
    y2: 476.6016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01E0E9"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M726,188.6c-43.1,0.1-81.6,35.1-86.1,78.2l-4.7,48.1c-2.3,23.2,14.4,42.1,37.6,42.1s44-19,46.4-42.1l5-47.8 c1.6-15-4.8-28.1-15.7-35.5c-6.6-4.5-16-3.3-22.3,3c0,0-0.1,0.1-0.1,0.1c-0.9,0.9-0.5,2.4,0.8,2.5c1.5,0.1,3.3,0.3,4.7,0.5 c13.3,2.9,22.3,14.8,20.7,29.4l-5,47.8c-1.8,16.9-16.6,30.1-33.3,30.1c-16.6,0-28.7-13.5-26.9-30.4l5-47.6 c3.8-36.5,36.4-66.5,72.9-66.5c36.5,0,63.3,29.7,59.5,66.2l-5,47.8c-3.8,36.4-36.2,66.4-72.7,66.6c-7.8,0-15.2-1.3-21.9-3.7 c-4.2-1.5-8.7-2.3-13.3-2.3c-0.2,0-0.4,0-0.6,0c-3.6,0-7.1-0.3-10.4-0.9c-1.5-0.3-2.6,1.7-1.5,2.7c12.3,10.3,28.3,16.4,46.6,16.3 c43-0.3,81.3-35.6,85.8-78.6l4.9-47C800.9,224.3,769.3,188.4,726,188.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.5275,
    y1: -191.5838,
    x2: 884.5259,
    y2: 495.4146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01E0E9"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M630.6,381.5h-59.5c-1.8,0-3.2-1.5-3-3.3l32.2-306.6c0.2-1.5,1.5-2.7,3-2.7h54.1c1.8,0,3.2,1.5,3,3.3 l-14.1,134.6c-0.1,1.4,1.6,2.1,2.6,0.9c1.9-2.1,3.9-4.2,6-6.1c2.9-2.8,4.7-6.5,5.1-10.3l12.9-122.8l0.5-5.1c0.4-3.6-2.4-6.6-6-6.6 h-5.1h-60.2h-6.9c-3.1,0-5.7,2.3-6,5.4l-0.7,6.3l-32.9,312.7l-0.6,5.7c-0.4,3.6,2.4,6.6,6,6.6h5.7h78c1.4,0,2.2-1.8,1.2-2.7 c-1.9-1.7-3.8-3.5-5.6-5.3C637.9,382.9,634.4,381.5,630.6,381.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHubfit);
export default __webpack_public_path__ + "static/media/logo-hubfit.d852efcefea7b85a82ec4333a9948a01.svg";
export { ForwardRef as ReactComponent };